// extracted by mini-css-extract-plugin
export default {"mainContent":"maincontent_mainContent__IjIvU","sidebarOverlay":"maincontent_sidebarOverlay__26MwF"};